import { lazy } from "react";

const routes = [
  {
    path: "dashboard",
    component: lazy(() => import("../pages/Home/Dashboard")),
    exact: true,
  },
  {
    path: "search",
    component: lazy(() => import("../pages/Home/Search")),
    exact: true,
  },
  {
    path: "payment-proof",
    component: lazy(() => import("../pages/Home/PaymentProof")),
    exact: true,
  },
  {
    path: "new-entry/personal",
    component: lazy(() => import("../pages/Home/Entry/Personal")),
    exact: true,
  },
  {
    path: "new-entry/business",
    component: lazy(() => import("../pages/Home/Entry/Business")),
    exact: true,
  },
  {
    path: "new-entry/permit",
    component: lazy(() => import("../pages/Home/Entry/PermitEntry")),
    exact: true,
  },
  {
    path: "recommendations/business",
    component: lazy(() => import("../pages/Home/Recommendation/Business")),
    exact: true,
  },
  {
    path: "recommendations/personal",
    component: lazy(() => import("../pages/Home/Recommendation/Personal")),
    exact: true,
  },
  {
    path: "recommendations/general",
    component: lazy(() => import("../pages/Home/Recommendation/General")),
    exact: true,
  },
  {
    path: "recommandation-form",
    component: lazy(() =>
      import("../pages/Home/Recommendation/RecommendationForm")
    ),
    exact: true,
  },
  {
    path: "reports",
    component: lazy(() => import("../pages/Home/Report")),
    exact: true,
  },
  // admin routes
  {
    path: "admin/profile",
    component: lazy(() => import("../pages/Admin/Profile/Edit")),
    exact: true,
    isAdmin: true,
  },
  {
    path: "admin/settings",
    component: lazy(() => import("../pages/Admin/Settings/Settings")),
    exact: true,
    isAdmin: true,
  },
  {
    path: "admin/users",
    component: lazy(() => import("../pages/Admin/Users")),
    exact: true,
    isAdmin: true,
  },
  {
    path: "admin/search",
    component: lazy(() => import("../pages/Home/Search")),
    exact: true,
    isAdmin: true,
  },
  {
    path: "admin/payment-proof",
    component: lazy(() => import("../pages/Home/PaymentProof")),
    exact: true,
    isAdmin: true,
  },
  {
    path: "admin/recommandation-form",
    component: lazy(() =>
      import("../pages/Home/Recommendation/RecommendationForm")
    ),
    exact: true,
    isAdmin: true,
  },
  {
    path: "admin/recommendations/general",
    component: lazy(() => import("../pages/Home/Recommendation/General")),
    exact: true,
    isAdmin: true,
  },
  {
    path: "admin/recommendations/business",
    component: lazy(() => import("../pages/Home/Recommendation/Business")),
    exact: true,
    isAdmin: true,
  },
  {
    path: "admin/recommendations/personal",
    component: lazy(() => import("../pages/Home/Recommendation/Personal")),
    exact: true,
    isAdmin: true,
  },
  {
    path: "admin/personal",
    component: lazy(() => import("../pages/Home/Entry/Personal")),
    exact: true,
    isAdmin: true,
  },
  {
    path: "admin/business",
    component: lazy(() => import("../pages/Home/Entry/Business")),
    exact: true,
    isAdmin: true,
  },
  {
    path: "admin/permit",
    component: lazy(() => import("../pages/Home/Entry/PermitEntry")),
    exact: true,
    isAdmin: true,
  },
  {
    path: "admin/settings/welcome",
    component: lazy(() => import("../pages/Admin/Settings/Partials/Welcome")),
    exact: true,
    isAdmin: true,
  },
  {
    path: "admin/settings/letterhead",
    component: lazy(() =>
      import("../pages/Admin/Settings/Partials/Letterhead")
    ),
    exact: true,
    isAdmin: true,
  },
  {
    path: "admin/settings/certificate",
    component: lazy(() =>
      import("../pages/Admin/Settings/Partials/certificate")
    ),
    exact: true,
    isAdmin: true,
  },
];

export default routes;
